"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOperationLogger = void 0;
const http_interfaces_1 = require("../types/http.interfaces");
/**
 * Creates an Operation logger to track EM operations.
 * logger = createRequestLogger(); // logs = []
 * logger.next(RequestLogEntryType.Auth, "401"); // logs = [{Initial,"401"}]
 * logger.next(RequestLogEntryType.Retry, "304");// logs = [{Initial,"401"}, {Auth, "304"}]
 * logs = logger.complete("200"); // logs = [{Initial,"401"}, {Auth, "304"}, {Retry, "200"}]
 */
const createOperationLogger = (request) => {
    const logs = [];
    let _comp;
    /** Creates a function to close operation 'type' with provided start/end times */
    const _start = (type, startTime, request) => {
        const datetime = new Date();
        return (endTime, result, response) => {
            logs.push({
                type,
                duration: endTime - startTime,
                result,
                request: createRequestEntry(datetime, request, response),
            });
        };
    };
    /**
     * Creates a function to complete current operation and start a new 'type' operation
     * If that function is called it will roll operations with time marker taken when begin() was called
     */
    const beginStep = (type, request) => {
        const time = performance.now();
        return (result, response) => {
            _comp(time, result, response);
            _comp = _start(type, time, request);
        };
    };
    // Creates a function to push operation without closing the current one
    const logStep = (type, request, response) => {
        const push = _start(type, performance.now(), request);
        return (result) => push(performance.now(), result, response);
    };
    /** Completes current operation and starts a new 'type' operation */
    const nextStep = (type, result, request, response) => {
        beginStep(type, request)(result, response);
    };
    _comp = _start(http_interfaces_1.OperationLogEntryType.Initial, performance.now(), request);
    return {
        nextStep,
        beginStep,
        logStep,
        complete: (result, response) => {
            _comp(performance.now(), result, response);
            return logs;
        },
    };
};
exports.createOperationLogger = createOperationLogger;
function createRequestEntry(dateTime, request, response) {
    if (!request) {
        return undefined;
    }
    const hostname = response ? new URL(response.url).hostname : "";
    const requestEntry = {
        name: request.apiName || "",
        dateTime,
        method: request.method,
        hostname,
        requestHeaders: request.headers || {},
        responseHeaders: response?.headers || {},
        status: response?.status,
        performance: getPerformanceEntry(response?.url),
        authPerformanceLogs: request.authPerformanceLogs || {},
    };
    return requestEntry;
}
function getPerformanceEntry(url) {
    if (url) {
        const entries = performance.getEntriesByName(url);
        if (entries.length > 0 &&
            entries[entries.length - 1].entryType === "resource") {
            const entry = entries[entries.length - 1];
            return entry;
        }
    }
    return undefined;
}
